import { DatePicker } from 'core/ui/controls/DatePicker';
import { ModalUtils } from '../modal';

// En los componentes LegacyDatePicker se recupera el componente content para colgar de este el portal de DatePicker,
// se hace esto para evitar problemas al heredar de otros componentes html y que siempre herede este del componente content padre.

export class LegacyDatePicker<T> extends DatePicker<T> {

	override getParentDialogId(): string {
		const allIds = ModalUtils.getAllIds();
		const parentId = allIds[allIds.length - 1];

		return `dialog:${parentId}:content`;
	}
}